import { render, staticRenderFns } from "./DynamicInfo.vue?vue&type=template&id=671d7c03&scoped=true&"
import script from "./DynamicInfo.vue?vue&type=script&lang=ts&"
export * from "./DynamicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicInfo.vue?vue&type=style&index=0&id=671d7c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d7c03",
  null
  
)

export default component.exports